module.exports = __webpack_public_path__ + "img/certificate.9cf8ec26.png";